export const SET_CUSTOMER_ORIGIN = 'SET_CUSTOMER_ORIGIN';

export const CLEAR_REFERRAL = 'CLEAR_REFERRAL';
export const SET_REFERRAL = 'SET_REFERRAL';
export const SET_TOGGLE_PROMOTIONAL_TOAST = 'SET_TOGGLE_PROMOTIONAL_TOAST';

export const USER_REQUEST = 'USER_REQUEST';
export const USER_SUCCESS = 'USER_SUCCESS';
export const USER_FAILURE = 'USER_FAILURE';

export const PATCH_USER_REQUEST = 'PATCH_USER_REQUEST';
export const PATCH_USER_SUCCESS = 'PATCH_USER_SUCCESS';
export const PATCH_USER_FAILURE = 'PATCH_USER_FAILURE';

export const ADDRESSES_REQUEST = 'ADDRESSES_REQUEST';
export const ADDRESSES_SUCCESS = 'ADDRESSES_SUCCESS';
export const ADDRESSES_FAILURE = 'ADDRESSES_FAILURE';
export const CREATE_ADDRESS_SUCCESS = 'CREATE_ADDRESS_SUCCESS';

export const PAYMENT_METHODS_REQUEST = 'PAYMENT_METHODS_REQUEST';
export const PAYMENT_METHODS_SUCCESS = 'PAYMENT_METHODS_SUCCESS';
export const PAYMENT_METHODS_FAILURE = 'PAYMENT_METHODS_FAILURE';
export const CREATE_PAYMENT_METHOD_SUCCESS = 'CREATE_PAYMENT_METHOD_SUCCESS';
export const PAYPAL_PAYMENT_METHODS_REQUEST = 'PAYPAL_PAYMENT_METHODS_REQUEST';
export const PAYPAL_PAYMENT_METHODS_SUCCESS = 'PAYPAL_PAYMENT_METHODS_SUCCESS';
export const PAYPAL_PAYMENT_METHODS_FAILURE = 'PAYPAL_PAYMENT_METHODS_FAILURE';
export const DELETE_PAYPAL_PAYMENT_METHODS_REQUEST = 'DELETE_PAYPAL_PAYMENT_METHODS_REQUEST';

export const RECOMMENDATIONS_REQUEST = 'RECOMMENDATIONS_REQUEST';
export const RECOMMENDATIONS_FAILURE = 'RECOMMENDATIONS_FAILURE';
export const RECOMMENDATIONS_SUCCESS = 'RECOMMENDATIONS_SUCCESS';

export const SET_LIVECHAT_GENERATION = 'SAVE_LIVECHAT_GENERATION';
export const SET_LIVECHAT_OPENING = 'SAVE_LIVECHAT_OPENING';

export const SUPPLEMENTS_VARIANT_FETCH_REQUEST = 'SUPPLEMENTS_VARIANT_FETCH_REQUEST';
export const SUPPLEMENTS_VARIANT_FETCH_SUCCESS = 'SUPPLEMENTS_VARIANT_FETCH_SUCCESS';
export const SUPPLEMENTS_VARIANT_FETCH_ERROR = 'SUPPLEMENTS_VARIANT_FETCH_ERROR';

export const SET_USER_COUNTRY = 'SET_USER_COUNTRY';

export const SEEN_PROMOTIONAL_MODAL = 'SEEN_PROMOTIONAL_MODAL';
